// L'onglet Sonar de la fiche d'une personnalité suivie (16 octobre 2026).
// Jamais un nombre de voix : des parts. Jamais « sondage » ni « électeurs » pour ceux qui en parlent.
export default {
  titre: 'Le Sonar de {qui}',
  texte: 'Posez une question, testez un message ou comparez jusqu’à quatre options auprès des groupes de ceux qui en parlent : chacun réagit avec ses mots, et la synthèse dit ce qui porte, chez qui, et quoi éviter.',
  nouvelle: 'Nouvelle étude',
  chargement: 'Chargement…',
  liste: 'Les études',
  vide: {
    titre: 'Aucune étude pour l’instant',
    texte: 'Lancez la première : une question sur {qui}, un tweet à tester avant de le publier, ou plusieurs versions d’une annonce à départager.',
  },
  genres: {
    question: { court: 'Question', titre: 'Poser une question', aide: 'Ce qu’ils pensent d’un sujet, d’une proposition, d’une polémique.' },
    message: { court: 'Message', titre: 'Tester un message', aide: 'Un post, une annonce, une riposte : comment chaque groupe le reçoit.' },
    ab: { court: 'Comparaison', titre: 'Comparer des options', aide: 'De deux à quatre versions d’un message, ou des propositions : chacune a son score, la meilleure se voit d’un coup d’œil.' },
  },
  enCours: 'En cours…',
  enCoursLong: 'Les groupes réagissent : l’étude se rend en une minute environ.',
  echec: 'Échec',
  echecLong: 'Cette étude n’a pas pu se faire. Relancez-la.',
  barreAria: '{f} % favorables, {n} % neutres, {d} % défavorables',
  pct: '{n} %',
  synthese: 'Ce qu’il faut retenir',
  sens: { favorable: 'favorables', neutre: 'neutres', defavorable: 'défavorables' },
  retenue: 'Option {v} :',
  classement: {
    titre: 'Le classement',
    meilleure: 'Meilleure option',
    premiere: 'En tête',
    sur: 'sur 100',
    fourchette: '{bas} ~ {haut}',
    preferent: '{n} la préfèrent aux autres',
    enTete: 'en tête, {score} sur 100',
    aria: 'Option {v} : {score} sur 100, entre {bas} et {haut}',
    avance: { nette: 'Nettement devant', courte: 'Devant de peu', egalite: 'Au coude à coude' },
  },
  scoresGroupe: 'Le score de chaque option dans ce groupe',
  recommandations: 'À faire',
  aEviter: 'À éviter',
  parGroupe: 'Groupe par groupe',
  comme: 'comme {nom}',
  reaction: 'Réaction {x}',
  intensite: { forte: 'forte', nette: 'nette', moderee: 'modérée', faible: 'faible' },
  relais: '{n} le relaieraient',
  preferenceAria: '{a} % préfèrent A, {b} % préfèrent B',
  preferent: '{v} : {n}',
  voix: '{prenom}, {age} ans',
  pasDesElecteurs: 'Ceux qui parlent d’une personnalité ne sont pas ses électeurs : ces réactions disent comment un message circule dans la conversation, pas comment on vote.',
  fenetre: { titre: 'Nouvelle étude' },
  etapes: { type: 'Le type', contenu: 'Le contenu', groupes: 'Les groupes' },
  champs: {
    question: 'La question',
    questionExemple: 'Que pensez-vous de la proposition de {qui} sur les retraites ?',
    contexte: 'Le contexte (facultatif)',
    contexteExemple: 'Un tweet pour annoncer la présentation du programme',
    message: 'Le message à tester',
    messageExemple: 'Le texte tel qu’il serait publié',
    option: 'Option {v}',
  },
  groupesAide: 'Les groupes de ceux qui en parlent qui réagiront. Tous sont cochés.',
  aucunGroupe: 'Aucun groupe n’a encore son persona : ils se dessinent après quelques jours d’écoute.',
  ajouterOption: 'Ajouter une option',
  retirerOption: 'Retirer l’option {v}',
  partConversation: '{n} de la conversation',
  lancer: 'Lancer l’étude',
  manque: {
    question: 'Écrivez la question.',
    message: 'Écrivez le message à tester.',
    versions: 'Écrivez au moins deux options, sans en laisser de vide.',
    groupes: 'Cochez au moins un groupe.',
  },
}
